import { render } from "./Arena_Clone_Item.vue?vue&type=template&id=393e33f2&scoped=true"
import script from "./Arena_Clone_Item.vue?vue&type=script&lang=js"
export * from "./Arena_Clone_Item.vue?vue&type=script&lang=js"

import "./Arena_Clone_Item.vue?vue&type=style&index=0&id=393e33f2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-393e33f2"]])

export default __exports__